var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-spinner',{staticClass:"v-ext-display-loading",attrs:{"size":"20","line-fg-color":"var(--blue-grey-200)","line-bg-color":"var(--blue-grey-50)"}})}
var staticRenderFns = []

export { render, staticRenderFns }